import { HTTP, HTTP_TOKEN } from './http'

export const login = (data) => {
  return HTTP.post('auth/login', data)
    .then((result) => {
        return result.data
    });
}

export const recoveryPassword = data => {
  return HTTP.post("user/recovery-password", data).then(result => {
    return result.data;
  });
};


export const changePassword = data => {
  return HTTP.post("user/change-password", data).then(result => {
    return result.data;
  });
};

export const acceptInvite = data => {
  return HTTP.post("user/accept-invite", data).then(result => {
    return result.data;
  });
};

export const createAccount = data => {
  return HTTP.post("register", data).then(result => {
    return result.data;
  });
};

export const checkIsLogged = data => {
  return HTTP_TOKEN.get("auth/check-is-logged", data).then(result => {
    return result.data;
  });
};


